import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "@/components/layout/Sidebar";
import Topbar from "@/components/layout/Topbar";
import Footer from "@/components/layout/Footer";
import DummyButton from "@/components/DummyButton";
import { DemoBanner } from "@/components/DemoBanner";

export default function AppLayout() {
  const [collapsed, setCollapsed] = useState(localStorage.getItem("cb_sidebar") === "1");
  const [bump, setBump] = useState(0);
  const toggle = (v) => {
    localStorage.setItem("cb_sidebar", v ? "1" : "0");
    setCollapsed(v);
  };
  return (
    <div className="min-h-screen flex cb-shell">
      <Sidebar collapsed={collapsed} setCollapsed={toggle} />
      <div className="flex-1 min-w-0 flex flex-col">
        <DemoBanner refreshKey={bump} />
        <Topbar />
        <main className="flex-1 p-5 sm:p-7 cb-scroll cb-pop">
          <div key={bump}><Outlet /></div>
        </main>
        <Footer />
      </div>
      <DummyButton onAdded={() => setBump((b) => b + 1)} />
    </div>
  );
}
